module.exports = __webpack_public_path__ + "plane-classic-granite.d94106d5b21ce702ca79.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/plane-classic-granite.svg
// module id = ../../../../../src/assets/img/plane-classic-granite.svg
// module chunks = main